// @ts-strict-ignore
import {Component, inject, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {IMappingIdentifier, Modules, Scope} from "@models";
import {
	SimConfigurationService,
	SimDeviceMappingService,
	SimSystemExtendedService,
	SimUserExtendedService,
	SimUtilityService,
} from "@services";
import {Translations} from "@translations";
import {TranslateService} from "@ngx-translate/core";

export interface DialogData_VersionDialogInput extends MatDialogDataBaseInput {}

export interface DialogData_VersionDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-version-dialog",
	templateUrl: "./version-dialog.component.html",
	styleUrls: ["./version-dialog.component.scss"],
	standalone: false,
})
export class VersionDialogComponent extends BasicMaterialDialog<
	VersionDialogComponent,
	DialogData_VersionDialogInput,
	DialogData_VersionDialogOutput
> {
	readonly translate = inject(TranslateService);
	T = Translations;
	Scope = Scope;
	Modules = Modules;

	SimConfigurationService = SimConfigurationService;
	hasLicenseModule = SimConfigurationService.hasLicenseModule;
	allModules = SimUtilityService.getStringValuesOfEnum(Modules);

	public clientProperties = SimDeviceMappingService.clientProperties;
	public version: string = null;
	public lastUpdate: string = null;
	public serverIp: string = null;
	public webSocketId: string = null;
	public availableFreeSpace: string;
	public identifier: IMappingIdentifier = null;

	constructor(
		private _simSystemService: SimSystemExtendedService,
		public simUserService: SimUserExtendedService,
		_injector: Injector,
	) {
		super(_injector);

		this._simSystemService.getSystemInformation().then((systemInformationResult) => {
			if (systemInformationResult) {
				this.version = systemInformationResult.version;
				this.lastUpdate = systemInformationResult.lastUpdate.toString();
				this.serverIp = systemInformationResult.serverIp;
				this.webSocketId = systemInformationResult.webSocketId;
				this.availableFreeSpace = SimUtilityService.formatBytes(systemInformationResult.availableFreeSpace);
			} else {
				this.version = "No information";
				this.lastUpdate = "No information";
			}
		});

		this._simSystemService.getMappingIdentifier().then((data) => {
			this.identifier = data;
		});
	}
}
